/* eslint-disable no-unused-vars */
import React, { useRef, useState } from "react";
import "./applicationstep.scss";
import { Card, Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import CustomAccordion from "../../atoms/CustomAccordion";
import { useSelector } from "react-redux";
import { ModalOverlay } from "../../atoms/Modal";
import { pensionWiseGuidanceCompletionContent } from "../../constants/constants";

const ApplicationStep = (props) => {
  const {
    steps: initialAppSteps,
    guide,
    pension,
    choose,
    data,
    bankDetails,
  } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );

  const [openIndex, setOpenIndex] = useState(null);
  const [openWhatToExpectPopup, setOpenWhatToExpectPopup] = useState(false);

  const handleAccordionClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Card className="application-step">
      <Card.Body className="p-0">
        <Row>
          <Col md={12} className="mb-fourty ps-0">
            <p className="guidance">Step-by-step retirement process</p>
          </Col>
        </Row>
        <Row className="ourter-bg">
          <Col md={12} className="bg-text ps-0">
            These are the steps to your online application. We’ll save completed
            sections for 30 days (excluding banking details), so you can pause
            and re-start if you wish.
          </Col>
        </Row>
        {initialAppSteps?.map((item, index) => {
          index = index + 1;
          return (
            <Row className="ourter-bg custom-accordion" key={index}>
              {item.isComplete === true ? (
                <CustomAccordion
                  illutrationOpened={props.illutrationOpened}
                  investorId={props.investorId}
                  miId={props.miId}
                  faiId={props.faiId}
                  snId={props.snId}
                  leId={props.leId}
                  key={index}
                  eventKey={index}
                  isOpen={openIndex === index}
                  bgColor="bgcolor-white"
                  identifier={item.identifier}
                  headertext={item?.title}
                  variant="icon-twenty-eight-px"
                  iconname="form-fields-success-tick"
                  headingNav="Show more"
                  headingNavClose="Show Less"
                  handleClick={() => handleAccordionClick(index)}
                  title="I have read important information regarding pension scams, tax, state benefits and my right to shop around"
                  subTitle="I have read the risk warnings with each pension option at"
                  underLineText="tpt.co.uk/risk-warnings"
                  selectedRetirementDate={
                    !guide?.pensionPaymentRequiredImmediately
                      ? guide?.pensionStartDate
                      : "I would like to receive my pension payment as soon as possible"
                  }
                  pensionWiseGuidance={[
                    guide?.receivedGuidanceFromPensionWise
                      ? pensionWiseGuidanceCompletionContent?.RECEIVED_GUIDANCE_FROM_PENSIONWISE
                      : "",
                    guide?.receivedAdviceFromFCA
                      ? pensionWiseGuidanceCompletionContent?.RECEIVED_ADVICE_FROM_FCA
                      : "",
                    guide?.wishToOptOutGuidanceFromPW
                      ? pensionWiseGuidanceCompletionContent?.WISH_TO_OPT_OUT_GUIDANCE_FROM_PW
                      : "",
                  ]}
                  pension={pension}
                  choose={choose}
                  data={data}
                  bankDetails={bankDetails}
                  applyShadow={false}
                />
              ) : (
                <Card
                  className={
                    item.isBegin === true ? "bg-turquoise" : "bg-white"
                  }
                >
                  <Card.Body className="p-0">
                    <Row className="mt-2">
                      <Col md={10} className="ps-1">
                        <h3 className="heading">
                          {item.isBegin ? (
                            <span className="step-num-outer">
                              <span className="step-num-indicator">
                                {index}
                              </span>
                            </span>
                          ) : item.isUpComing ? (
                            <span className="step-num-grey">{index}</span>
                          ) : (
                            ""
                          )}
                          {item?.title === "Guidance and advice" ? (
                            "Guidance and advice"
                          ) : (
                            <>{item?.title}</>
                          )}
                        </h3>
                      </Col>
                      <Col md={2} className="text-end pt-1 text-end-tablet">
                        <Icons iconname="clock" variant="icon-sixteen-px" />
                        <span className="ps-2">{item.timer}</span>
                      </Col>
                      <hr className="path-line" />
                    </Row>

                    <Row className="mt-2">
                      <Col md={10}>
                        <Row>
                          <Col
                            md={item?.infoDocSection?.infoOrDoc ? 6 : 12}
                            className="ps-1"
                          >
                            {item?.description
                              .split("\n\n")
                              .map((str, index) => (
                                <p key={index}>{str}</p>
                              ))}
                          </Col>
                          {item?.infoDocSection?.infoOrDoc ? (
                            <Col md={6}>
                              <p className="sub-heading">
                                {item?.infoDocSection?.infoOrDoc}
                              </p>
                              <ul>
                                {item?.infoDocSection?.infoDocList.map(
                                  (infoDoc, index) => {
                                    const text = infoDoc?.name || "";
                                    const lowerText = text.toLowerCase();
                                    const whatToExpectIndex =
                                      lowerText.indexOf("what to expect");
                                    if (whatToExpectIndex !== -1) {
                                      const before = text.slice(
                                        0,
                                        whatToExpectIndex //eslint-disable-line
                                      );
                                      const clickable = text.slice(
                                        whatToExpectIndex,
                                        whatToExpectIndex +
                                          "what to expect".length //eslint-disable-line
                                      );
                                      const after = text.slice(
                                        whatToExpectIndex +
                                          "what to expect".length //eslint-disable-line
                                      );
                                      return (
                                        <li key={index}>
                                          {before}
                                          <span
                                            onClick={() =>
                                              setOpenWhatToExpectPopup(true)
                                            }
                                            className="what-to-expect-style"
                                          >
                                            {clickable}
                                          </span>
                                          {after}
                                        </li>
                                      );
                                    }
                                    return (
                                      <li
                                        key={index}
                                        dangerouslySetInnerHTML={{
                                          __html: text,
                                        }}
                                      />
                                    );
                                  } //eslint-disable-line
                                )}
                              </ul>
                            </Col>
                          ) : (
                            ""
                          )}
                        </Row>
                      </Col>
                      <Col md={2} className="text-end beginbtn">
                        {item?.isBegin === true ? (
                          <Buttons
                            className="primary mt-3"
                            name="Begin"
                            variantname="icon-sixteen-px"
                            handleClick={(e) => props.handleBeginClick(e, item)}
                          />
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
              {item.isBegin === true && index !== 6 ? (
                <div className="lock-section">
                  <hr className="path-line" />
                  <p>Please complete the previous step first</p>
                  <Icons
                    iconname="icons-locked"
                    variant="icon-twenty-four-px"
                  />
                </div>
              ) : (
                ""
              )}
              {/* complete */}
            </Row>
          );
        })}
        <ModalOverlay
          popup="whatToExpect"
          show={openWhatToExpectPopup}
          onHide={(e) => {
            if (e !== undefined) {
              e.preventDefault();
            }
            setOpenWhatToExpectPopup(false);
          }}
        />
      </Card.Body>
    </Card>
  );
};
export default ApplicationStep;
